// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AppointmentCalendarResponse } from './appointment-calendar-response';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.StartAppointmentCalendarResponse */
/* istanbul ignore next */
@GandalfModel
export class StartAppointmentCalendarResponse extends GandalfModelBase {

	@GandalfProperty({ designType: AppointmentCalendarResponse })
	appointmentCalendar!: AppointmentCalendarResponse | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

}
